import axios from "axios";
import Cookie from "js-cookie";

export const postAxios = async (api, data) => {
  axios.interceptors.request.use((request) => {
    const token = Cookie.get("token");
    request.headers["Authorization"] = token && `Token ${token}`;
    request.headers["Accept-Language"] =
      localStorage.getItem("i18nextLng") || "fa";
    return request;
  });
  return axios.post(api, data);
};

export const getAxios = async (api) => {
  axios.interceptors.request.use((request) => {
    const token = Cookie.get("token");
    request.headers["Authorization"] = token && `Token ${token}`;
    request.headers["Accept-Language"] =
      localStorage.getItem("i18nextLng") || "fa";
    return request;
  });
  return axios.get(api);
};

export const deleteAxios = async (api) => {
  axios.interceptors.request.use((request) => {
    const token = Cookie.get("token");
    request.headers["Authorization"] = token && `Token ${token}`;
    request.headers["Accept-Language"] =
      localStorage.getItem("i18nextLng") || "fa";
    return request;
  });
  return axios.delete(api);
};

export const putAxios = async (api, data) => {
  axios.interceptors.request.use((request) => {
    const token = Cookie.get("token");
    request.headers["Authorization"] = token && `Token ${token}`;
    request.headers["Accept-Language"] =
      localStorage.getItem("i18nextLng") || "fa";
    return request;
  });
  return axios.put(api, data);
};
